import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { useAsync } from 'react-use';
import { EntityFilterQuery } from '@backstage/catalog-client';
import { TextField } from '@material-ui/core';
import { Entity } from '@backstage/catalog-model';

interface EntryType {
  title: string;
  entity: Entity;
}

export const TeamInput = (props: {
  onChange: (name?: string) => void;
  label?: string;
  helperText?: string;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  id?: string;
  value?: string;
}) => {
  const catalogApi = useApi(catalogApiRef);
  const catalogFilter = [
    { kind: ['Group'], 'spec.type': 'team' },
  ] as EntityFilterQuery;

  const { value: entities, loading } = useAsync(() =>
    catalogApi.getEntities(
      catalogFilter ? { filter: catalogFilter } : undefined,
    ),
  );

  const entityRefs = entities?.items.filter(e => e.spec?.type === 'team');
  const entries = loadEntries();

  const defaultProps = {
    options: entries,
    getOptionLabel: (option: EntryType) => (option?.title ? option.title : ''),
  };

  return (
    <FormControl
      margin="dense"
      required={props.required}
      fullWidth={props.fullWidth}
    >
      <Autocomplete
        {...defaultProps}
        id={props.id}
        value={toInitialValue()}
        loading={loading}
        freeSolo
        renderInput={params => (
          <TextField
            {...params}
            label={props.label ? props.label : 'Team'}
            margin="dense"
            helperText={
              props.helperText
                ? props.helperText
                : 'Select the responsible team'
            }
            FormHelperTextProps={{ margin: 'dense', style: { marginLeft: 0 } }}
            variant="outlined"
            required={props.required}
            InputProps={params.InputProps}
            error={props.error}
          />
        )}
        onChange={(_, newValue) =>
          props.onChange((newValue as EntryType)?.entity?.metadata?.name)
        }
      />
    </FormControl>
  );

  function toInitialValue(): EntryType | string {
    const initialEntry = entries.find(
      e => e.entity.metadata.name === props.value,
    );
    return initialEntry || '';
  }

  function loadEntries(): EntryType[] {
    const entities = entityRefs
      ?.map(it => toEntry(it))
      .sort((a, b) => (a.title < b.title ? -1 : 1));
    return entities || [];
  }

  function toEntry(entity: Entity): EntryType {
    return {
      title: entity.metadata.title!,
      entity: entity,
    };
  }
};
